import { render } from "./OptStatViewManagerPatients.vue?vue&type=template&id=56e6d10a&scoped=true"
import script from "./OptStatViewManagerPatients.vue?vue&type=script&lang=js"
export * from "./OptStatViewManagerPatients.vue?vue&type=script&lang=js"

import "./OptStatViewManagerPatients.vue?vue&type=style&index=0&id=56e6d10a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e6d10a"]])

export default __exports__